var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('widget-edit-dialog', {
    attrs: {
      "dashboard-id": _vm.dashboardId,
      "date-range": _vm.dateRange,
      "custom-parameters": _vm.customParameters,
      "widget-id": "__new"
    },
    on: {
      "saved": function ($event) {
        return _vm.$emit('created');
      },
      "close": function ($event) {
        _vm.show = false;
      }
    },
    model: {
      value: _vm.show,
      callback: function ($$v) {
        _vm.show = $$v;
      },
      expression: "show"
    }
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };